export default function onValueChanging(result, options) {
  //console.log('onValueChanging', result, options);
  // clear the "other" text if other input is selected
  if (options.question && options.question.hasOther) {
    // unwrap from additional <span> we have added for "other" textbox
    const el = document.querySelector("span.form-group");
    if (el) {
      const parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    }

    if (options.question.getType() === "radiogroup")
      options.question.comment = "";
  }
}
